module.exports = __webpack_public_path__ + "static/media/email.fd0fbee8.svg";